import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router';

import 'bulma/css/bulma.min.css';

import './assets/css/main.css';
import './assets/css/animations.css';
import './assets/css/responsive.css';

import { useTemplateStore } from './store/modules/template';

const app = createApp(App);

const pinia = createPinia();
app.use(pinia);
app.use(router);

const templateStore = useTemplateStore();

templateStore.fetchTemplateConfig().finally(() => {
  const template = templateStore.currentTemplate || 'default';
  
  import(`./themes/${template}/styles/variables.css`).catch(() => {
    console.warn(`Theme ${template} variables.css not found, using default`);
    return import('./themes/default/styles/variables.css');
  });
  
  import(`./themes/${template}/styles/main.css`).catch(() => {
    console.warn(`Theme ${template} main.css not found, using default`);
    return import('./themes/default/styles/main.css');
  });
  
  app.mount('#app');
});
